import { useState, useEffect } from 'react';
import EmojiRow from '../parts/EmojiRow';
import EmojiDropping from '../animations/EmojiDropping';
import NitroButton from '../parts/NitroButton';

import ping from '../../sounds/ping.mp3';
//import beep from '../../sounds/beep.mp3';
import beep from '../../sounds/Ping-3.wav';

const Emoji = ({qData, pageStyle, nextStep}) => {

  const [prompts, setPrompts] = useState([]);
  const [emojiClicked, setEmojiClicked] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [showUi, setShowUi] = useState(true);
 const [collectResponses, setCollectResponses] = useState([]);

  const allPrompts = qData.prompts;
  let promptsHtml;

  useEffect(() => {

    // need to 'send' prompts to screen, 1 at a time
    // after a delay, load the first one
    setTimeout(function () {
      setPrompts([...prompts, allPrompts[0]])

      let audio = new Audio(ping);
      audio.volume = 0.75;
      audio.play();

    }, 1999)

  }, []);

  const respond = (index, emoji, textInput, promptText) => {

    // save response...
    let response = {
      'prompt number': index,
      'prompt text': promptText,
      'emoji selected': emoji,
      'text entered': textInput
    }
    setCollectResponses(current => [...current, response]);

    // trigger animations (matter js in here)
    setShowUi(false);
    setEmojiClicked(emoji);

    let audio = new Audio(beep);
    audio.volume = 0.75;
    audio.play();

    // wait,
    setTimeout(function () {

      // then send next prompt if there is one
      if ((index + 1) == allPrompts.length) {
        //return nextStep; // didn't work
        // show btn instead for now
        setIsValid(true)
      } else {
        setPrompts([...prompts, allPrompts[index + 1]])

        // and play the ping sound
        let audio = new Audio(ping);
        audio.volume = 0.75;
        audio.play();

        // and show the ui for the response
        setShowUi(true);
      }

    }, 999)



  }

  promptsHtml = prompts.map((content, index) =>
    <EmojiRow key={index} content={content} rowId={index} showUi={showUi} respond={respond} />
  );

  const onSubmit = (data) => {

    const dataToSend = {
      "questionId": qData.id,
      "emojiValue": collectResponses
    }

    nextStep(dataToSend);
  }

  return (
    <>
      <div className="grow py-12 emoji_interface">
        <div className="container max-w-lg">
          {promptsHtml}
        </div>
      </div>
      <NitroButton label="Next" formIsValid={isValid} onClick={onSubmit} />
      <EmojiDropping emoji={emojiClicked} showUi={showUi} />
    </>

  );
}

export default Emoji;
